import type { PlatformListItem } from "../../api/types";

export const ONBOARDING_STEPS = [
  "Platform registered",
  "Clients added",
  "Blueprint connected",
  "Pushed to prod",
] as const;

// What each step means, in the same order as ONBOARDING_STEPS.
export const ONBOARDING_STEP_DESCRIPTIONS = [
  "The platform is registered in Intility ID.",
  "The platform has at least one client: an SPA, an API or another service.",
  "The platform is linked to its blueprint.",
  "The platform is live in production, with all earlier steps done.",
] as const;

// One flag per entry in ONBOARDING_STEPS, from what the API already returns.
// The former "Login wired up" step is retired with its onboarding key: the
// wired-up claim now lives on each client (ADR-0060 decision 8), so the
// platform's Clients tab says it better than a checklist key ever did.
export function onboardingSteps(
  platform: Pick<PlatformListItem, "clientCount" | "slug">,
): boolean[] {
  return [
    true,
    platform.clientCount > 0,
    platform.slug !== null,
    // Nothing records that a platform has been pushed to prod yet, so no
    // platform can reach "Completed" until it does.
    false,
  ];
}

export function isOnboardingComplete(steps: readonly boolean[]): boolean {
  return steps.every(Boolean);
}
